var DashboardComponent = (function () {
    function DashboardComponent() {
    }
    DashboardComponent.prototype.ngOnInit = function () {
        this.title = "Dashboard";
    };
    return DashboardComponent;
}());
export { DashboardComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/dashboard/dashboard.component.ts.pre-build-optimizer.js